module.exports = __webpack_public_path__ + "static/media/lockIcon.1287390f.svg";